<template>
    <div>
        <app-card
            headerIcon="notifications"
            :heading="$t('lang.RecentNotifications')"
            colClasses=""
            customClasses="mb-0"
            :fullScreen="true"
            :reloadable="true"
            :closeable="true"
            :fullBlock="true"
            :footer="true"
            :reload="reload"
        >
            <recent-notifications></recent-notifications>
            <v-spacer slot="footer"></v-spacer>
            <v-btn slot="footer" color="primary" @click="$router.push({ name: 'notifications' })" small>{{ $t("lang.view_all") }}</v-btn>
            <v-btn slot="header" icon small @click="refreshNotifications"><v-icon>refresh</v-icon></v-btn>
        </app-card>
    </div>
</template>
<script>
import RecentNotifications from "App_components/Widgets/RecentNotifications.vue";
import { mapActions } from "vuex";
export default {
    components: {
        RecentNotifications,
    },
    data() {
        return {
            name: "recent_notifications",
            reload: false,
        };
    },
    methods: {
        ...mapActions(["fetchNotifications"]),
        async refreshNotifications() {
            this.reload = true;
            this.$store.commit("mutate", {
                property: "notifications",
                with: [],
            });
            this.fetchNotifications({ body: { options: 1 } }).then((data) => {
                this.reload = false;
            });
        },
    },
};
</script>
